// extracted by mini-css-extract-plugin
export var hiddenPrint = "utilities-module--hidden-print--upplL";
export var visuallyHidden = "utilities-module--visually-hidden--i24-y";